/**
 * @namespace CylindoEvents
 * @description A collection of Cylindo-specific events that can be used to listen for changes in the Cylindo viewer.
 */
export class CylindoEvents {
  /** @static @constant {string} Event triggered when a Cylindo viewer is fullscreen changed */
  static fullscreenChanged = 'fullscreen-changed';
}

/**
 * Event fired when a Cylindo viewer is fullscreen changed
 * https://pdp.cylindo.com/API/cylindo-viewer#fullscreen-change
 * @extends {Event}
 */
export class CylindoViewerFullscreenChangedEvent extends Event {
  /**
   * Creates a new CylindoViewerFullscreenChangedEvent
   * @param {boolean} isFullscreen - The new fullscreen state
   */
  constructor(isFullscreen) {
    super('fullscreen-changed', { bubbles: true });
    this.detail = isFullscreen;
  }
}
